import { safeServices, safeStatement, safeHighlights } from "@/data/siteConfig";
import { SectionHeader } from "@/components/SectionHeader";
import { CallButton } from "@/components/CallButton";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export const SafeSpecialist = () => (
  <section
    className="grain relative overflow-hidden bg-ink py-24 md:py-32"
    data-testid="safe-specialist"
  >
    <div className="pointer-events-none absolute -left-40 top-24 h-[500px] w-[500px] rounded-full bg-gold/[0.05] blur-[130px]" />
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-8">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <SectionHeader overline="Safe Specialists" title="Difficult safe work is our specialty" />
          <p className="mt-6 text-lg leading-relaxed text-steel">{safeStatement}</p>

          <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden border border-white/10 bg-white/10">
            {safeHighlights.map((s) => (
              <div key={s.label} className="bg-ink p-6">
                <div className="font-heading text-3xl font-black text-gold">{s.value}</div>
                <div className="mt-1 text-xs uppercase tracking-wide text-steel">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <CallButton size="lg" showNumber testid="safe-call-btn" />
          </div>
        </div>

        <RevealGroup className="grid gap-4 sm:grid-cols-2">
          {safeServices.map((s, i) => {
            const Icon = s.icon;
            return (
              <RevealItem key={s.slug}>
                <div
                  className="group flex h-full flex-col border border-white/10 bg-ink-surface p-6 transition-colors duration-300 hover:border-gold/40"
                  data-testid={`safe-service-${s.slug}`}
                >
                  <div className="mb-4 flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center rounded-sm border border-white/10 bg-ink text-gold transition-colors duration-300 group-hover:border-gold/50">
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="font-heading text-xs font-bold text-white/15">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-white">{s.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-steel">{s.short}</p>
                </div>
              </RevealItem>
            );
          })}
        </RevealGroup>
      </div>
    </div>
  </section>
);
